import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import DriverFormDialog from "./DriverFormDialog";

function DriverSelectDialog({
  open,
  onClose,
  onSuccess,
  onPick,
  customerData,
  carData,
}) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleCarSkip = () => {
    onPick && onPick([]);
    onClose && onClose();
  };

  const handleSelect = async (carData, driverData) => {
    onPick && onPick(driverData);
    onClose && onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display={"flex"} justifyContent={"space-between"}>
            เลือกคนขับรถ {carData?.type} ({carData?.license})
            <Button onClick={() => setOpenDialog(true)}>
              เพิ่มข้อมูลคนขับรถ
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent>
          {customerData?.drivers?.length ? (
            <Grid container spacing={2}>
              {customerData.drivers.map((driver) => (
                <Grid item xs={12} sm={4} md={3} key={driver.id}>
                  <Card
                    variant="outlined"
                    sx={{ cursor: "pointer", "&:hover": { boxShadow: 3 } }}
                    onClick={() => handleSelect(carData, driver)}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {driver.name}
                      </Typography>
                      <Box display="flex" justifyContent="space-between">
                        <Typography>{driver?.surname}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {driver?.idCard}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>ไม่มีข้อมูลคนขับรถ</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            size="large"
            sx={{ width: "100px" }}
            onClick={handleCarSkip}
          >
            ข้าม
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={{ width: "100px" }}
            onClick={onClose}
          >
            ปิด
          </Button>
        </DialogActions>
      </Dialog>

      <DriverFormDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        customerData={customerData}
        onSuccess={onSuccess}
      />
    </>
  );
}

export default DriverSelectDialog;
